import { useNavigate } from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';
import { defaultTheme, StyledButton } from '@canopysecurity/component-library';

const SidebarContainer = styled.aside`
  height: 100%;
  background-color: ${defaultTheme.background.main};
`;
const SidebarContent = styled.div`
  padding: 1%;
`;
const ListContent = styled.div`
  ul {
    list-style-type: none;
  }

  li {
    margin: 2px 0;
  }
`;
const SidebarButton = styled(StyledButton)`
  margin-top: 2%;
  margin-bottom: 2em;
`;
const Borderline = styled.div`
  margin-top: 2%;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 2%;
`;

export default function SideBar() {
  const navigate = useNavigate();

  return (
    <>
      <SidebarContainer>
        <SidebarContent>
          <ListContent>
            <ul>
              <li>
                <SidebarButton onPress={() => navigate('/')}>
                  Home
                </SidebarButton>
              </li>
              <Borderline />
              <li>
                <SidebarButton
                  onPress={() => navigate('/create-release-package')}
                >
                  Create Release Package
                </SidebarButton>
              </li>
              <li>
                <SidebarButton onPress={() => navigate('/manage-tags')}>
                  Manage Tags
                </SidebarButton>
              </li>
              <li>
                <SidebarButton onPress={() => navigate('/device-details')}>
                  Device Details
                </SidebarButton>
              </li>
            </ul>
          </ListContent>
        </SidebarContent>
      </SidebarContainer>
    </>
  );
}
